<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <section>
    <div class="content-wrapper pos-rel-md">
      <h1 class="faq-heading">{{ pageData.title || 'FAQs' }}</h1>
      <div class="separator"></div>
      <h2 class="search-title">Search for a topic</h2>
      <div class="faq-search">
        <div class="faq-search-field">
          <form [formGroup]="searchForm">
            <input
              type="text"
              placeholder="Start typing your search"
              class="faq-search-field"
              (blur)="onBlur()"
              (focus)="onFocus()"
              [class.searching]="searching"
              formControlName="searchTerm"
            />
          </form>
        </div>
        <div
          class="faq-search-results"
          *ngIf="showSearchResults && searchDone && faqSearchResults.length"
        >
          <ul>
            <li *ngFor="let result of faqSearchResults">
              <a routerLink="/app/my-profile/faqs/{{ result.uid }}">{{
                removeBold(result.title)
              }}</a>
            </li>
          </ul>
        </div>
        <div
          class="faq-search-results"
          *ngIf="showSearchResults && searchDone && !faqSearchResults.length"
        >
          <p>
            Oops! Look like we have no results for that search term. Try another
            term or <a routerLink="/app/contact">get in touch</a>.
          </p>
        </div>
      </div>
    </div>

    <div class="content-wrapper pos-rel-md">
      <div
        class="faq-categories"
        *ngIf="!categoryRetrievalError; else faqError"
      >
        <div class="faq-category" *ngFor="let cat of faqCategories">
          <div class="faq-category-title" (click)="toggleFAQCategory($event)">
            <h2>{{ removeBold(cat.title) }}</h2>
          </div>
          <div class="faq-category-faqs">
            <div class="faq" *ngFor="let faq of cat.faqs">
              <div
                class="faq-question"
                (click)="toggleFAQ($event)"
                [innerHTML]="removeBold(faq.title)"
              ></div>
              <div class="faq-answer">
                <app-render-markdown
                  [content]="faq.answer"
                ></app-render-markdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      class="mobile-bg-img"
      [src]="pageData?.mobile_img?.data?.attributes?.url"
    />
  </section>
</div>

<ng-template #faqError>
  <div class="faq top-faq">
    <p class="ta-center" style="padding: 16px">
      There was a problem retrieving FAQs. Please refresh, search for your
      question, or try again later.
    </p>
  </div>
</ng-template>
